import { AlertTriangle, FileText, Mail, Phone, Shield } from "lucide-react";

const LegalPolicy = () => {
  return (
    <div className="bg-white">
      {/* Hero */}
      <section className="bg-gradient-to-r from-brand-blue to-brand-teal text-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-medium mb-6">
              <FileText size={16} />
              Legal Policy
            </div>
            <h1 className="font-heading text-4xl md:text-5xl font-bold leading-tight mb-4">
              Legal Policy
            </h1>
            <p className="text-white/90 text-lg leading-relaxed">
              Behavioral Health Navigation & Workforce Agency provides non-clinical
              navigation, referral, and support services designed to help individuals
              access appropriate behavioral health resources.
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-14 md:py-20 bg-brand-neutral">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="px-6 sm:px-8 lg:px-10 py-8 sm:py-10">
              <div className="border-b border-gray-100 pb-6 mb-8">
                <p className="text-sm font-semibold tracking-wide uppercase text-brand-orange mb-2">
                  Effective Date
                </p>
                <p className="text-brand-text text-base">March 26, 2026</p>
              </div>

              <div className="space-y-10">
                <div>
                  <h2 className="font-heading text-2xl md:text-3xl font-bold text-brand-blue mb-4">
                    Agency Governance
                  </h2>
                  <p className="text-gray-700 leading-8">
                    Behavioral Health Navigation & Workforce Agency (BHNWA) operates
                    under the governance and accountability of{" "}
                    <a
                      href="https://hispresencechapel.org/"
                      target="_blank"
                      rel="noreferrer"
                      className="text-brand-orange font-semibold hover:underline"
                    >
                      His Presence Chapel Inc.
                    </a>
                    , a registered 501(c)(3) nonprofit organization in Texas, United
                    States.
                  </p>
                </div>

                <div className="rounded-2xl bg-red-50 border border-red-100 p-6">
                  <div className="flex items-start gap-3">
                    <AlertTriangle className="text-red-600 mt-1 flex-shrink-0" size={22} />
                    <div>
                      <h2 className="font-heading text-2xl font-bold text-red-700 mb-3">
                        Non-Clinical Services Disclaimer
                      </h2>
                      <div className="space-y-4 text-gray-700 leading-8">
                        <p>
                          BHNWA does not provide medical, psychiatric, or clinical
                          services, and does not diagnose, treat, or prescribe for any
                          mental health or medical conditions.
                        </p>
                        <p>
                          All information and support provided through our services are
                          for guidance and coordination purposes only and should not be
                          considered medical advice.
                        </p>
                        <p>
                          Individuals are encouraged to seek care from licensed
                          healthcare professionals for diagnosis, treatment, and
                          clinical services.
                        </p>
                        <p className="font-semibold text-red-700">
                          In the event of a medical or mental health emergency,
                          individuals should contact emergency services immediately or
                          call 911.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <h2 className="font-heading text-2xl md:text-3xl font-bold text-brand-blue mb-4">
                    Limitation of Liability
                  </h2>
                  <div className="space-y-4 text-gray-700 leading-8">
                    <p>
                      BHNWA and His Presence Chapel Inc. are not liable for any
                      decisions made or actions taken based on information provided
                      through our services or website.
                    </p>
                    <p>
                      Use of our services is voluntary and at the discretion of the
                      individual.
                    </p>
                  </div>
                </div>

                <div className="rounded-2xl bg-brand-blue/5 border border-brand-blue/10 p-6">
                  <div className="flex items-start gap-3">
                    <Shield className="text-brand-blue mt-1 flex-shrink-0" size={22} />
                    <div>
                      <h2 className="font-heading text-2xl font-bold text-brand-blue mb-3">
                        Contact Information
                      </h2>
                      <div className="space-y-4 text-gray-700 leading-8">
                        <div className="flex items-center gap-3">
                          <Mail className="text-brand-orange flex-shrink-0" size={18} />
                          <a
                            href="mailto:info@behavioralhealthnavigation.org"
                            className="hover:text-brand-orange transition-colors break-all"
                          >
                            info@behavioralhealthnavigation.org
                          </a>
                        </div>
                        <div className="flex items-center gap-3">
                          <Phone className="text-brand-orange flex-shrink-0" size={18} />
                          <a
                            href="tel:+18328878254"
                            className="hover:text-brand-orange transition-colors"
                          >
                            +1 (832) 887-8254
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="pt-2 border-t border-gray-100">
                  <p className="text-sm text-gray-500 leading-7">
                    © Behavioral Health Navigation & Workforce Agency. All Rights Reserved.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalPolicy;